import { forwardRef, useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";

const AppToast = forwardRef((props, ref) => {
  const [mobileStyle, setMobileStyle] = useState({});
  const prevWidthRef = useRef(window.innerWidth);

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w === prevWidthRef.current) return;
      prevWidthRef.current = w;
      setMobileStyle(
        w <= 640
          ? { maxWidth: "calc(100vw - 1rem)", width: "100%", margin: "0 auto" }
          : {}
      );
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return (
    <Toast
      ref={ref}
      position="top-center"
      baseZIndex={1600}
      style={mobileStyle}
      {...props}
    />
  );
});

AppToast.displayName = "AppToast";

export default AppToast;
